<template>
  <div class="page">
    <section class="container">
      <pre>activityMaxPeople:::: {{ activityMaxPeople }}</pre>
      <pre>package or product Name: {{ activeProductDetails.Name }}</pre>
      <pre>activity.Name: {{ activity.Name }}</pre>
      <pre>activity.IsPrivateTour: {{ activity.IsPrivateTour }}</pre>
      <pre>missingMin: {{ missingMin }}</pre>
      <pre>PTR: {{ privateTourRate }}</pre>
      <!--      <transition name="slide-vertical">-->
      <!--        <p-->
      <!--          class="bg-gray p-1 border_radius flex_start"-->
      <!--          v-show="-->
      <!--            !isPackage &&-->
      <!--              totalActivityParticipants <= activeProductDetails.MaxPeople-->
      <!--          "-->
      <!--        >-->
      <!--          Add up to-->
      <!--          <strong>&nbsp;{{ activeProductDetails.MaxPeople }}&nbsp;</strong>-->
      <!--          guests.-->
      <!--        </p>-->
      <!--      </transition>-->

      <transition name="slide-vertical">
        <p
          :key="'no-more-than-guest'"
          class="bg-gray p-1 border_radius flex_start"
          :class="{
            '-error shake-animation': totalActivityParticipants == activeProductDetails.MaxPeople,
          }"
          v-show="!isPackage && totalActivityParticipants == activeProductDetails.MaxPeople"
        >
          No more than
          <strong>&nbsp;{{ activeProductDetails.MaxPeople }}&nbsp;</strong>
          {{ activity.OverrideRateLabel ? (activeProductDetails.MaxPeople == 1 ? activity.RateLabelSingular : activity.RateLabelPlural) : "guests" }}
          allowed.
        </p>
      </transition>

      <transition name="slide-vertical">
        <p
          class="bg-gray p-1 border_radius flex_start"
          v-if="!activity.IsPrivateTour && isPackage && totalActivityParticipants < activeProductDetails.Participants"
        >
          Add a total of
          <strong>&nbsp;{{ activeProductDetails.Participants }}&nbsp;</strong>
          guest{{ activeProductDetails.Participants === 1 ? "" : "s" }}.
        </p>
      </transition>

      <transition name="slide-vertical">
        <p
          class="bg-gray p-1 error border_radius flex_start"
          v-if="!activity.IsPrivateTour && isPackage && totalActivityParticipants > activeProductDetails.Participants"
        >
          Remove
          {{ totalActivityParticipants - activeProductDetails.Participants }}
          for a total of
          <strong>&nbsp;{{ activeProductDetails.Participants }}&nbsp;</strong>
          guests.
        </p>
      </transition>

      <p class="bg-gray p-1 border_radius flex_start" v-show="activity.IsPrivateTour">
        How many guests will be a part of your private party?
      </p>
      <guests-rate
        :packageParticipants="activeProductDetails.Participants"
        :isPackage="isPackage"
        :totalActivityParticipants="totalActivityParticipants"
        :disableAdd="noMoreGuests"
        :isPrivateTour="activity.IsPrivateTour"
        v-for="r in cloneRates"
        :rate="r"
        :activity="activity"
        :ultimateMaxPeople="activityMaxPeople"
        :key="'guest-activity-rate-' + r.EntityHierarchyRateKey"
      />
    </section>

    <page-header :fixed="true" :undo="true">
      <h3 v-if="isPackage">
        Assign
        {{ activity.OverrideRateLabel ? activity.RateLabelPlural : "guests" }}
      </h3>
      <h3 class="foo" v-else>
        Add
        {{ activity.OverrideRateLabel ? activity.RateLabelPlural : "guests" }}
      </h3>
      <template v-slot:undo>
        <div class="back Cancel"></div>
        <a @click.prevent="undo" class="text-blue chevron left" href>&nbsp;</a>
      </template>
    </page-header>

    <page-footer v-if="isPackage">
      <template v-slot:text>
        <div v-if="!activity.IsPrivateTour">
          <h4
            :class="{
              'text-red': totalActivityParticipants !== activeProductDetails.Participants && totalActivityParticipants > 0,
            }"
          >
            {{ totalActivityParticipants }} of {{ activeProductDetails.Participants }} guests
          </h4>
          <small class="shake-animation" v-if="totalActivityParticipants > activeProductDetails.Participants">Too many guests!</small>
          <small class="shake-animation text-red" v-if="totalActivityParticipants && missingMin"
            >"{{ missingMin.Name }}" requires minimum of&nbsp;{{ missingMinMin }}</small
          >
        </div>
      </template>
      <template v-slot:button>
        <button
          @click.prevent="done"
          href="#"
          style="min-width: 100px;"
          :disabled="disableDone || missingMin"
          class="button blue ml-1 text-center"
          :class="{
            'scale-animation': totalActivityParticipants == activeProductDetails.Participants,
          }"
        >
          <span>Done</span>
        </button>
      </template>
    </page-footer>

    <page-footer v-else>
      <template v-slot:text>
        <h4>
          {{ totalActivityParticipants }}
          {{
            activity.OverrideRateLabel
              ? totalActivityParticipants == 1
                ? activity.RateLabelSingular
                : activity.RateLabelPlural
              : totalActivityParticipants != 1
              ? "guests"
              : "guest"
          }}
        </h4>
        <transition-group name="slide-vertical">
          <small :key="'guest-max'" class=" shake-animation" v-show="!isPackage && totalActivityParticipants == activeProductDetails.MaxPeople"
            >Max of {{ activeProductDetails.MaxPeople }}
            {{
              activity.OverrideRateLabel ? (activeProductDetails.MaxPeople == 1 ? activity.RateLabelSingular : activity.RateLabelPlural) : "guests"
            }}</small
          >
          <small :key="'guest-missing-min'" class="shake-animation text-red" v-if="totalActivityParticipants && missingMin"
            >"{{ missingMin.Name }}" requires minimum of&nbsp;{{ missingMinMin }}</small
          >
        </transition-group>
      </template>
      <template v-slot:button>
        <button
          @click.prevent="done()"
          href="#"
          style="min-width: 100px;"
          :disabled="!enableDoneButton"
          class="button blue ml-1 text-center"
          :class="{ 'scale-animation': enableDoneButton }"
        >
          {{ activity.AppointmentDate || activity.AppointmentTypeKey == 3 ? "Done" : "Next" }}
        </button>
      </template>
    </page-footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import guestMixin from "../mixins/guestMixin.js";

import PageFooter from "../components/PageFooter.vue";

import GuestsRate from "./GuestsRate.vue";

export default {
  name: "Guests",
  data: function() {
    return {
      cloneRates: [],
    };
  },
  props: ["details", "isPrivateTour"],
  components: {
    GuestsRate,
    PageFooter,
  },
  mixins: [guestMixin],
  watch: {
    cloneRates: {
      handler() {
        if (this.activity.IsPrivateTour && this.privateTourRate) {
          this.privateTourRate.Participants = this.totalActivityParticipants > 0 ? 1 : 0;
        }
      },
      deep: true,
    },
  },
  methods: {
    undo() {
      //this.computedActivityRates = this.cloneRates;
      setTimeout(() => {
        this.$router.go(-1);
      }, 250);
    },

    done() {
      this.computedActivityRates = this.cloneRates;

      setTimeout(() => {
        this.$router.go(-1);
      }, 0);
    },
    calculateMinParticipants(rate) {
      var isPrivate = this.activity.IsPrivateTour;
      var participants = rate.Participants;
      var min = rate.MinForPrivateTourOnly ? (isPrivate ? rate.MinParticipants : false) : rate.MinParticipants;
      if (rate.IsRequired) {
        return min ? min : 1;
      }
      return participants > 0 ? (min ? min : 0) : 0;
    },
  },

  activated() {
    //alert("activated");
    this.cloneRates = JSON.parse(JSON.stringify(this.computedActivityRates));

    let el = document.querySelector(".product_details");
    el.scrollTop = 0;
  },
  beforeRouteLeave(to, from, next) {
    let pathmatch = /\/\d*\/activity$/;
    if (pathmatch.test(to.path) && window.parent) {
      window.parent.postMessage({ detail_leave: true }, "*");
    }
    next();
  },
  computed: {
    ...mapGetters(["activeProductDetails"]),
    noMoreGuests() {
      if (!this.activity.IsPrivateTour) return this.disableAdd;
      else return false;
    },
    activity() {
      if (this.activeProductDetails && this.activeProductDetails.Activities) {
        let activity = this.activeProductDetails.Activities.find((ele) => {
          return ele.EntityHierarchyKey * 1 === this.$route.params.entityHierarchyKey * 1;
        });
        if (activity) {
          return activity;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    privateTourRate() {
      return this.cloneRates.find((ele) => {
        return ele.IsPrivateTourRate;
      });
    },
    disableDone() {
      if (this.activity.IsPrivateTour) {
        return this.totalActivityParticipants == 0;
      } else if (this.totalActivityParticipants && this.totalActivityParticipants !== this.activeProductDetails.Participants) {
        return true;
      }
      return false;
    },

    missingMin() {
      if (this.cloneRates) {
        return this.cloneRates.find((rate) => {
          return rate.Participants < this.calculateMinParticipants(rate);
        });
      } else {
        return false;
      }
    },
    missingMinMin() {
      return this.calculateMinParticipants(this.missingMin);
    },
    activityMaxPeople() {
      if (this.activity && this.activity.MaxPeople) {
        return this.activity.MaxPeople;
      }
      return 100000;
    },

    enableDoneButton() {
      let carry_on = true;

      this.cloneRates.forEach((rate) => {
        //console.log("\n--rate.Name ", rate.Name);
        //console.log("-----rate.Participants ", rate.Participants);
        //console.log("-----rate.MinParticipants ", rate.MinParticipants);
        if (rate.Participants < this.calculateMinParticipants(rate)) {
          //console.log("\n return false");
          carry_on = false;
          return false;
        }

        // if (rate.Participants < 1) {
        //   console.log("\n return false");
        //   carry_on = false;
        //   return false;
        // }
      });

      if (carry_on && this.totalActivityParticipants > 0 && this.totalActivityParticipants <= this.activeProductDetails.MaxPeople) {
        return true;
      }

      return false;
    },

    isPackage() {
      return !!this.activeProductDetails.PackageKey && !this.activeProductDetails.ShowFirstActivityOnly;
    },

    // isPrivateTour() {
    //   //if (this.activeProductDetails.PackageKey) {
    //
    //   if (this.activity) {
    //     return this.activity.IsPrivateTour;
    //   }
    //
    //   return null;
    // },

    totalActivityParticipants() {
      let t = 0;
      if (this.cloneRates) {
        this.cloneRates.forEach((ele) => {
          if (!ele.IsPrivateTourRate) {
            t = t + ele.Participants;
          }
        });
      }

      return t;
    },
    // _computedActivityRates() {
    //   if (this.$route.params.entityHierarchyKey) {
    //     let findActivity = this.activeProductDetails.Activities.find(ele => {
    //       return (
    //         ele.EntityHierarchyKey == this.$route.params.entityHierarchyKey
    //       );
    //     });
    //     if (findActivity) {
    //       return findActivity.Rates;
    //     } else {
    //       return [];
    //     }
    //   }
    //
    //   return [];
    // },

    computedActivityRates: {
      get: function() {
        if (this.$route.params.entityHierarchyKey) {
          if (this.activity) {
            return this.activity.Rates;
          } else {
            return [];
          }
        }

        return [];
      },
      set: function(newValue) {
        // alert(
        //   "set this.$route.params.entityHierarchyKey: " +
        //     this.$route.params.entityHierarchyKey
        // );
        // let findActivity = this.activeProductDetails.Activities.find(ele => {
        //   return (
        //     ele.EntityHierarchyKey == this.$route.params.entityHierarchyKey
        //   );
        // });

        if (this.activity) {
          //findActivity.Rates = JSON.parse(JSON.stringify(newValue));
          this.$set(this.activity, "Rates", JSON.parse(JSON.stringify(newValue)));
        }
      },
    },
  },
};
</script>

<style></style>
